export const API_URLS = {
  DRIVER_PICKUP_ALLOCATION: `/skybiz/driverAllocation/pickup`,
  DRIVER_DROPOFF_ALLOCATION: `/skybiz/driverAllocation/dropoff`,
  FLIGHT_ALLOCATION: `/skybiz/flightAllocation`,
  FLIGHT_UNALLOCATION: `/skybiz/flightAllocation/unAllocatedBooking`,
  VIEW_BOOKING: `/skybiz/viewBooking`,
  LOGIN: `/user/skybiz/login`,
  WEATHER_URL: `/v1/forecast.json`,
  COMMENTS: `/skybiz/calender/details`,
  POSTCOMMENTS: `/skybiz/calender/comments`,
  BOOKINGS_DATA: `/skybiz/calender/totalbookings`,
  PASSENGER_MANIFEST: `/skybiz/passengerManifest/`,
  ADD_NOT_ON_THIS_FLIGHT: `/skybiz/passengerManifest/pax-on-flight`,
  BREAKFAST_DATA: `/skybiz/operations/breakfast`,
  PAYMENT_BREAKUP: `/skybiz/operations/paymentBreakUp`,
  AGENTS: '/skybiz/viewBooking/agents',
  TRIP_STATUS: '/skybiz/viewBooking/trip-status',
  CALENDER_DETAILS: '/skybiz/calender',
  COUNTRY_PAX_COUNT: '/skybiz/operations/countries-pax-count',
  OPS_FLIGHT_DETAILS: '/skybiz/operations/flights',
  WEATHER_DETAILS: '/skybiz/operations/weather',
  CANCEL_REASON_DETAILS: '/skybiz/operations/flight-cancellation-reasons',
  CANCEL_FLIGHT: '/skybiz/operations/flight-cancel',
  ADD_DRIVER: '/skybiz/operations/add-driver',
  GET_OPERATION_DETAILS: '/skybiz/operations/details',
  GET_STAFF_ALLOCATION: '/skybiz/operations/driver/allocation',
  GET_LOCATION_LIST: '/skybiz/operations/owner-location',
  POST_IMAGE_URL: '/skybiz/operations/google-drive-link',
  DRIVER_LIST: '/skybiz/operations/driver/list',
  PILOT_LIST: '/skybiz/operations/pilot/list',
  CREW_LIST: '/skybiz/operations/crew/list',
  UPDATE_DRIVER: '/skybiz/operations/driver',
  ADD_PILOT: '/skybiz/operations/add-pilot',
  BOOKING_CHECKLIST_ACTIONED: '/skybiz/operations/checklist-actioned',
  TOTAL_BOOKING_ZONE_WISE: '/skybiz/operations/bookings-zonewise',
  ADD_CREW: '/skybiz/operations/add-crew',
  UPDATE_CREW: '/skybiz/operations/crew',
  UPDATE_PILOT: '/skybiz/operations/pilot',
  GOOGLE_MAP_BOOKINGS_DETAILS: '/skybiz/operations/google-map-bookings',
  ADD_DUTY_MANAGER_PIC: '/skybiz/operations/duty-manager-pic',
  ADD_TEMP: '/skybiz/operations/add-temp',
  STAFF_DETAILS: '/skybiz/operations/staff/details',
  CALENDER_DETAILS_HEADER: '/skybiz/operations/calender/details',
  DELETE_STAFF: '/skybiz/operations/delete/driver',
  ADD_OFL: '/skybiz/operations/add-ofl',
  UPDATE_FLIGHT: '/skybiz/operations/flight',
  FORCAST_OPTIONS: '/skybiz/operations/forecast-options',
  FORCAST_TRAVEL_STATUS: '/skybiz/operations/forecast-travel-status',
  CALENDER_AVAILABILITY_STATUS: '/skybiz/availability/status',
  CALENDER_UPDATE_AVAILABILITY_STATUS: '/skybiz/availability',
  COMPLIANCE_URL: '/skybiz/compliance',
  STAFF_COMPLIANCE: '/skybiz/compliance/staff',
  UPDATE_EQUIPMENT_COMPLIANCE: '/skybiz/compliance/compliance-equipment',
  UPDATE_STAFF_COMPLIANCE: '/skybiz/compliance/compliance-staff',
  UPDATE_STAFF: '/skybiz/compliance/staff-compliance',
  UPDATE_STAFF_IN_COMPLIANCE: '/skybiz/compliance/staff-equipment',
  UPDATE_COMMENTS: '/skybiz/operations/update-general-comments',
  REACTIVATE_FLIGHT_CANCEL: '/skybiz/operations/reactivate-flight-cancel',
  BOOKING_RATE: '/skybiz/operations/booking-rate',
  OPERATION_CHECKLIST: '/skybiz/operations/operation-checklist',
  OPERATION_DRIVER_ALLOCATION_LIST: '/skybiz/operations/drivers/allocation',
  OPERATION_CREW_ALLOCATION_LIST: '/skybiz/operations/crew/allocation',
  OPERATION_PILOT_ALLOCATION_LIST: '/skybiz/operations/pilot/allocation',
  AVAILABILITY_COMMENTS: '/skybiz/calender/availability-comments',
  ADD_RES: '/skybiz/operations/update-res',
  TEMP_LIST: `/skybiz/operations/temp-list`,
   TODAYS_TEMP: `/skybiz/operations/temp-today`,
};
